export class BrowserCheck {
  static isIEOrEdge() {
    return /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  }
}
